<template>
  <footer-item :clickHandler="goToContact" :text="contactLabel"></footer-item>
</template>

<script>

import FooterItem from './FooterItem';

export default {
  computed: {
    contactLabel() {
      return this.$gettext('Contact');
    }
  },
  methods: {
    goToContact() {
      const prefix = this.$language.isChinese() ? '/cn' : '';
      const page = this.$context.isTop20Talent ? 'contact' : 'about-us#contact';
      window.open(`${prefix}/${page}`, '_blank');
    }
  },
  components: {FooterItem}
};
</script>
